import {initRequest, RequestMethod} from "../../middlewares/request/requestActions";

export const RESOURCE_HANDLER_PACKAGE_SET = "resource-handler/package/set";
export const RESOURCE_HANDLER_STATE_RESET = "resource-handler/package/unset";
export const RESOURCE_HANDLER_VIEW_FETCH = "resource-handler/view/fetch";
export const RESOURCE_HANDLER_VIEW_CLEAR = "resource-handler/view/clear";
export const RESOURCE_HANDLER_TEMPLATE_FETCH = "resource-handler/template/fetch";
export const RESOURCE_HANDLER_TEMPLATE_CLEAR = "resource-handler/template/clear";
export const RESOURCE_HANDLER_RESOURCE_BACKUP = "resource-handler/resource/backup";

export const setPackage = packageId => ({
  type: RESOURCE_HANDLER_PACKAGE_SET,
  payload: {
    packageId: packageId
  }
});

export const resetState = () => ({
  type: RESOURCE_HANDLER_STATE_RESET
});

export const fetchView = (nodeId, viewId) =>
  initRequest(
    RESOURCE_HANDLER_VIEW_FETCH,
    `Nodes/${nodeId}/views/${viewId}`,
    RequestMethod.GET,
    undefined,
    undefined,
    undefined,
    undefined,
    () => true
  );

export const fetchTemplate = (nodeId, templateId) =>
  initRequest(
    RESOURCE_HANDLER_TEMPLATE_FETCH,
    `Nodes/${nodeId}/templates/${templateId}`,
    RequestMethod.GET,
    undefined,
    undefined,
    undefined,
    undefined,
    () => true
  );

export const clearView = () => ({
  type: RESOURCE_HANDLER_VIEW_CLEAR
});

export const clearTemplate = () => ({
  type: RESOURCE_HANDLER_TEMPLATE_CLEAR
});

export const backupResource = () => ({
  type: RESOURCE_HANDLER_RESOURCE_BACKUP
});
